module.exports = fox._r("flash/expressInstall.swf", __webpack_public_path__ + "_/_/_/root/flash/expressInstall.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/flash/expressInstall.swf
// module id = 642
// module chunks = 4